<template>
    <div>

    <div class="accordion__wrapper justify-space-between">
        <div class="accordion__entry">
            <div class="accordion__header d-flex justify-space-between align-center" @click="toggleAccordion()">
                <h4>{{title}}</h4>
                <div :style="openAccordion ? 'height:24px': 'transform: rotate(45deg);height:24px'">
                    <Icon icon="fluent-mdl2:cancel" width="24px" style="font-weight: bold;"/>
                </div>
            </div>

            <div v-if="type == 'application'" v-show="openAccordion" class=" pb-5">
                <p>{{$t("message.applicationText")}}</p>
                <div class="accordion__steps my-3">
                <!-- <div class="accordion__steps my-3 d-flex flex-wrap"> -->
                        <div class="accordion__step--content" >
                            <div class="accordion__steps--bullet">1</div>
                            <div class="accordion__steps--text">{{$t('message.applicationSteps[0]')}}</div>
                        </div>
                        <div  class="accordion__step--arrow" >
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="41px" viewBox="0 0 40 41" version="1.1"><title>ED8C8E45-B4EB-4BAE-A1E8-4EF136F2029A@2x</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Relaunch-Loxone--Detail" transform="translate(-602.000000, -2730.000000)"><g id="IC-arrow-right" transform="translate(602.000000, 2730.534007)"><g id="Outline_Icons" transform="translate(0.825000, 12.375000)" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.65"><g id="Group"><polyline id="Path" points="29.7 0 37.95 8.25 29.7 16.5"/><line x1="37.95" y1="8.25" x2="0" y2="8.25" id="Path"/></g></g><g id="Invisible_Shape"><rect id="Rectangle" x="0" y="0" width="39.6" height="39.6"/></g></g></g></g></svg>
                        </div>
                        <div class="accordion__step--content" >
                            <div class="accordion__steps--bullet">2</div>
                            <div class="accordion__steps--text">{{$t('message.applicationSteps[1]')}}</div>
                        </div>
                        <div class="accordion__step--arrow d-none d-lg-flex" >
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="41px" viewBox="0 0 40 41" version="1.1"><title>ED8C8E45-B4EB-4BAE-A1E8-4EF136F2029A@2x</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Relaunch-Loxone--Detail" transform="translate(-602.000000, -2730.000000)"><g id="IC-arrow-right" transform="translate(602.000000, 2730.534007)"><g id="Outline_Icons" transform="translate(0.825000, 12.375000)" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.65"><g id="Group"><polyline id="Path" points="29.7 0 37.95 8.25 29.7 16.5"/><line x1="37.95" y1="8.25" x2="0" y2="8.25" id="Path"/></g></g><g id="Invisible_Shape"><rect id="Rectangle" x="0" y="0" width="39.6" height="39.6"/></g></g></g></g></svg>
                        </div>

                        <div class="accordion__step--content" >
                            <div class="accordion__steps--bullet">3</div>
                            <div class="accordion__steps--text">{{$t('message.applicationSteps[2]')}}</div>
                        </div>
                        <div class="accordion__step--arrow" >
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="41px" viewBox="0 0 40 41" version="1.1"><title>ED8C8E45-B4EB-4BAE-A1E8-4EF136F2029A@2x</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Relaunch-Loxone--Detail" transform="translate(-602.000000, -2730.000000)"><g id="IC-arrow-right" transform="translate(602.000000, 2730.534007)"><g id="Outline_Icons" transform="translate(0.825000, 12.375000)" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.65"><g id="Group"><polyline id="Path" points="29.7 0 37.95 8.25 29.7 16.5"/><line x1="37.95" y1="8.25" x2="0" y2="8.25" id="Path"/></g></g><g id="Invisible_Shape"><rect id="Rectangle" x="0" y="0" width="39.6" height="39.6"/></g></g></g></g></svg>
                        </div>
                        <div class="accordion__step--content" >
                            <div class="accordion__steps--bullet">4</div>
                            <div class="accordion__steps--text">{{$t('message.applicationSteps[3]')}}</div>
                        </div>
                </div> 
            </div>

            <div v-if="type == 'aboutLoxone'" class=" pb-5" v-show="openAccordion">
                <div v-html="$t('message.aboutLoxone')"></div>
                <a class="btn btn--ghost d-inline-block my-5" href="https://www.loxone.com/">{{$t('message.moreaboutLoxone')}}</a>
            </div>
   
            <div v-if="type == 'location'" class=" pb-5" v-show="openAccordion">
                <div class="container-fluid mb-3">
                    <v-img v-if="location.image" max-height="400" cover :src="location.image" alt=""/>
                    <v-img v-else max-height="400" cover :src="`https://jobs.loxone.com/wp-content/loxone/jobs-detail/src/assets/images/${temp_locationImages[location.title]}`"/>
                </div>
                <v-row>
                    <v-col cols="6" md="4">
                         <p><br>
                            {{location.street}}<br>
                            {{location.country}} | {{location.post_code}} {{location.city}}</p>
                    </v-col>
                    <v-col v-if="location.title != 'IT - Milan'">
                        <a target="_blank" :href="`https://www.google.com/maps?saddr=My+Location&daddr=${location.latitude},${location.longitude}`" >{{$t("message.showonmap")}}</a>
                    </v-col>
                </v-row>
            </div>
            <div v-if="type == 'similarJobs'" class="pb-5" v-show="openAccordion"> 
                <div class="d-flex flex-wrap my-5" style="flex-direction:row;">
                    <a :href="`https://jobs.loxone.com/de/jobs/detail/${s.zoho_id}`" v-for="s of similarJobs" :key="s" class="similarjob-links mb-5" style="flex: 1  50%" >{{s.title}}</a>
                </div>
            </div>
            <v-divider/>
        </div>
    </div>
    </div>
</template>


<script>
import { Icon } from '@iconify/vue';
    export default {
        data() {
            return {
                openAccordion: false,
                temp_locationImages: {
                    "CZ - 370 11 České Budějovice": "(c)Loxone_Basecamp-CZ_76.jpg",
                    "SK - 07 Vajnory": "(c)Loxone_Basecamp-Slovakia-35.jpg",
                    "UK - Theale RG7 4RA": "(c)Loxone-UK-The-Forum13.jpg",
                    "FR - 69740 Genas": "Branding_Office FR_2.jpeg",
                    "ES - 08271 Artés":"(c)Loxone_Showroom-Spain-03.jpg",
                    "IT - Milan": "PH-IT_location.jpg",
                    "DE - 30916 Isernhagen, Altwarmbüchen": "FS-Header-Locations-Isernhagen.jpg",
                    "AT - 4211 Alberndorf": "PH_Smart-Engineering-Building-New.jpg"
                },
            }
        },
        components: {
            Icon,
        },
        props: {
            title: {
                type: String,
            },
            location:{
                type: Object
            },
            type: {
                type: String,
            },
            similarJobs: {
                type: Array
            }
        },
        methods: {
            toggleAccordion(){
                this.openAccordion = !this.openAccordion;
            }
        },

    }

</script>


<style lang="css" scoped>
.accordion__step--arrow{
    padding-top: 25px;
    padding-bottom: 25px;
}

.accordion__step--content{
    width: 120px;
    margin: 0 auto;
}

.accordion__steps--bullet{
    background: #69C350;
    border-radius: 50%;
    font-size: 50px;
    line-height: 100px;
    height: 100px;
    text-align: center;
    color: #FFFFFF;
    width: 100px;
    font-family: 'averta-extrabold', Arial, Helvetica, sans-serif;
    margin: 0 auto;
}

.accordion__steps{
    display: grid;
    grid-template-columns: calc(calc(100% - 120px) / 4) 40px calc(calc(100% - 120px) / 4) 40px calc(calc(100% - 120px) / 4) 40px calc(calc(100% - 120px) / 4);
    padding-top: 20px;
}
.accordion__steps--text{
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 16px;
    line-height: 1.2em;
}
.accordion__step--arrow svg {
    transform: rotate(0deg) !important; /*overrite style.css*/
}
.accordion__header{
    cursor: pointer;
}
.accordion__header h4{
    font-size: 23px;
    line-height: 30px;
    padding: 30px 0 30px 0px;
    position: relative;
}


.accordion__header h4:before{
    transform: rotate(90deg);
}

@media(max-width: 960px) {
    .similarjob-links{
        flex: 1 100% !important;
    }
}

@media(max-width: 1280px) {
    .accordion__steps{
        display: grid;
        grid-template-columns: auto auto auto;
        padding-top: 20px;
        margin-right: 20px;
        margin-left: 20px;
    }
    .accordion__step--arrow{
        display: flex;
        justify-content: center;
    }
}


</style>